module.exports = __webpack_public_path__ + "img/publicbank.51b74116.svg";